<template>
  <v-row class="pt-5">
    <v-col
      v-for="(module, ind) in modules"
      :key="ind"
      @click="$router.push(buildRoute(module))"
      :cols="rCols('xs')"
      :sm="rCols('sm')"
      :md="rCols('md')"
      :lg="rCols('lg')"
      :xl="rCols('xl')"
    >
      <div :class="`mb-1 box-title-wrapper d-flex flex-column mx-auto align-center ${config.iconBgColor[themeName]}`">
        <module-icon-with-badge
          class="mx-auto my-auto"
          :unreadCountBadgeColor="badgeColor"
          :isUnreadCountFeatureEnabled="mx_isUnreadCountFeatureEnabled(module.type, module.instance)"
          :iconColor="iconColor"
          :badgeOutsideBox="badgeOutsideBox"
          :module="module"
          :unreadCount="mx_unreadCount(module)"
          :size="36"
        ></module-icon-with-badge>
      </div>
      <n-title
        :fColor="config.fontColor ? config.fontColor[themeName] : 'white'"
        class="mt-3 mb-5 align-center justify-center text-center"
        style="white-space: nowrap"
        >{{ $te(module.title) ? $t(module.title) : module.title }}</n-title
      >
    </v-col>
  </v-row>
</template>

<script>
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import navigationMixin from '@/mixins/navigationMixin';
import NTitle from '@/components/texts/NTitle';
import ModuleIconWithBadge from '@/components/icons/ModuleIconWithBadge.vue';
import { rCols as responsiveCols } from '@/common/utils';
export default {
  name: 'ModuleGrid',
  mixins: [common, configMixin, navigationMixin],
  components: {
    NTitle,
    ModuleIconWithBadge,
  },

  props: {
    config: {
      type: Object,
    },
  },

  methods: {
    rCols(viewSize) {
      return 12 / responsiveCols(this.cols, viewSize);
    },
  },
  computed: {
    cols() {
      return this.config.modulesPerRow;
    },

    iconBgColor() {
      return this.config.iconBgColor[this.themeName];
    },
    iconColor() {
      return this.config.iconColor[this.themeName];
    },
    badgeColor() {
      return this.config.badgeColor && this.config.badgeColor[this.themeName] ? this.config.badgeColor[this.themeName] : this.theme.unreadBadgeColor;
    },
    badgeOutsideBox() {
      return this.config.badgeOutsideBox;
    },
  },
};
</script>

<style scoped>
.box-title-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 5px;
}
</style>
